const SearchIcon = ({ props, onClick }) => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.096 5.90401C14.4945 5.29132 13.7775 4.80388 12.9865 4.46984C12.1956 4.1358 11.3462 3.96179 10.4876 3.95784C9.62902 3.9539 8.77813 4.1201 7.98412 4.44686C7.19011 4.77361 6.4687 5.25444 5.86157 5.86158C5.25443 6.46871 4.7736 7.19012 4.44684 7.98413C4.12009 8.77815 3.95388 9.62903 3.95783 10.4876C3.96177 11.3462 4.13579 12.1956 4.46983 12.9865C4.80387 13.7775 5.29131 14.4945 5.904 15.096C7.12675 16.2965 8.77409 16.9656 10.4876 16.9577C12.2012 16.9498 13.8423 16.2656 15.054 15.054C16.2656 13.8423 16.9498 12.2012 16.9577 10.4876C16.9656 8.7741 16.2965 7.12676 15.096 5.90401ZM4.49 4.49001C6.02282 2.95757 8.08315 2.06858 10.2497 2.00484C12.4162 1.9411 14.5252 2.70741 16.1455 4.14708C17.7658 5.58675 18.7749 7.591 18.9664 9.74998C19.1579 11.909 18.5175 14.0596 17.176 15.762L22.521 21.107L21.107 22.521L15.762 17.176C14.059 18.5126 11.9102 19.149 9.75406 18.9556C7.59787 18.7622 5.5967 17.7534 4.15878 16.1351C2.72085 14.5168 1.95449 12.4109 2.01604 10.2469C2.07759 8.08294 2.96241 6.02397 4.49 4.49001Z"
        fill="#777777"
      />
    </svg>
  );
};

export default SearchIcon;
